export default "__VITE_ASSET__BbJmpTsZ__"